import { Card } from 'antd';
import React from 'react';
import { useSelector } from 'react-redux';
import { RECONCILIATION_STATUS_COLOUR } from '../../../../../shared/constants/reconciliationConstants';
import { RootState } from '../../../../../store';
import { ReconciliationState } from '../../../../../store/models/reconciliationModel';
const ReconcilationStatusPanel = (): any => {
  const {reconciliationClaimDetail: {reconciliationStatus}}
   = useSelector((state: RootState): ReconciliationState => state.reconciliation || []);
  let statusClassName = '';
   RECONCILIATION_STATUS_COLOUR.map((colorObject: any): any => {
    if (colorObject.statusName === reconciliationStatus) {
      statusClassName = colorObject.class;
    }
  });
  const isReconciled = true;
  return (
    <Card className="panel-styles maximize-card">

      <span className={`fsize_lg bold status-text mr-10`}>
        {isReconciled ? 'Status' : 'Reconciled Status'}
      </span>
      <span className={`fsize_lg bold status-text ${statusClassName}`}>{reconciliationStatus && reconciliationStatus}</span>
    </Card>
  );
};
export default ReconcilationStatusPanel;
